import script from "./PublicContribution.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicContribution.vue?vue&type=script&setup=true&lang=js"

import "./PublicContribution.vue?vue&type=style&index=0&id=98e8d974&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98e8d974"]])

export default __exports__